import styled from 'styled-components';

export const PrimitiveCard = styled.div<{ selected?: boolean }>`
	background-color: ${({ theme }) => theme.gray[0]};
	border: 1px solid ${({ theme, selected }) => (selected ? theme.blue[500] : theme.gray[200])};
	border-radius: 8px;
	padding: 16px;
	transition: all 0.2s ease;
	min-height: 140px;
	display: flex;
	flex-direction: column;
	gap: 12px;

	&:hover {
		border-color: ${({ theme, selected }) => (selected ? theme.blue[500] : theme.gray[400])};
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
	}
`;

export const PrimitiveName = styled.div`
	font-size: 14px;
	font-weight: 600;
	color: ${({ theme }) => theme.gray[1000]};
	font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono',
		'Courier New', monospace;
`;

export const PrimitivePreview = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	min-height: 60px;
	width: 100%;
	flex: 1;
`;

export const PrimitiveGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
	gap: 24px;
	width: 100%;
`;
